import { useLocalStorage } from '@/hooks'
import { PageUiSchema } from '@/catalog-apps/components/AppPage2/types'
import { NoSearchResultsDisplay } from '@/components/ui/NoSeachResultsDisplay'
import { useAppPageLayout } from '@/catalog-apps/components/AppPage2/useAppPageLayout'
import { cn } from '@/lib/utils'
import { Separator } from '@/components/shadcn/separator'
import { Button } from '@/components/shadcn/button'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { Fragment, useMemo, useState } from 'react'
import { SearchInput } from '@/catalog-apps/components/component-library/shared/SearchInput'
import { ScrollArea } from '@/components/shadcn/scroll-area'

export function SavedPageLayouts() {
  const [search, setSearch] = useState('')
  const [savedPageLayouts] = useLocalStorage<PageUiSchema[]>('savedPageLayouts', [])
  const { loadPageLayout, currentLayoutId, createNewPageLayout } = useAppPageLayout()

  const filteredPageLayouts = useMemo(() => {
    if (!search) return savedPageLayouts
    const filteredItems = savedPageLayouts.filter(
      (layout) =>
        layout.title?.toLowerCase().includes(search.toLowerCase()) ||
        layout.description?.toLowerCase().includes(search.toLowerCase())
    )
    return filteredItems
  }, [search, savedPageLayouts])

  return (
    <div className="flex h-full flex-col">
      <h3 className="bg-foreground/5 py-2 text-center text-base font-medium italic">Saved page layouts:</h3>
      <div className="flex h-full flex-col">
        {savedPageLayouts.length > 0 && (
          <div className="h-[59px] p-3">
            <SearchInput className="w-full self-start" value={search} onChange={setSearch} />
          </div>
        )}
        <div className="flex h-[calc(100%-99px)] flex-col justify-between pt-2">
          <ScrollArea className="h-[calc(100%-59px)]">
            <div className="flex flex-col gap-y-2 px-3">
              {filteredPageLayouts.length === 0 && <NoSearchResultsDisplay />}
              {filteredPageLayouts.map((layout, i) => {
                const isCurrentLayout = layout.id === currentLayoutId
                return (
                  <Fragment key={layout.id}>
                    {i > 0 && <Separator />}
                    <button
                      onClick={() => loadPageLayout(layout.id)}
                      className={cn(
                        'block flex-col items-start border-l-4 border-transparent pl-3',
                        isCurrentLayout && 'border-primary'
                      )}
                    >
                      <h2 className="w-full truncate text-left text-sm font-medium">{layout.title}</h2>
                      <p className="w-full max-w-full truncate text-left text-xs text-muted-foreground">
                        {layout.description}
                      </p>
                    </button>
                  </Fragment>
                )
              })}
            </div>
          </ScrollArea>
          {!!currentLayoutId && (
            <div className="flex h-[60px] justify-center p-3">
              <Button variant="outline" size="sm" onClick={createNewPageLayout}>
                <IconPlusOutline className="size-4" />
                Add new
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
